import AspectRatioBox from './AspectRatioBox';
import ContentBg from './ContentBg';
import useScreenType from '../hook/useScreenType';

interface IProps {
  bgImg: string;
  className?: string;
  hasLastModified?: boolean;
}

export default function BigOverContentCardBgV4({
  bgImg,
  className,
  hasLastModified,
}: IProps) {
  const {screenType} = useScreenType();
  return (
    <div
      className={cn('relative', className, hasLastModified ? 'pt-32' : 'pt-24')}
    >
      <AspectRatioBox
        aspectRatio={BG_ASPECT_RATIO_MAP[screenType]}
        className="overflow-hidden rounded-16"
      >
        <ContentBg
          src={bgImg}
          bgClassName="-translate-y-50"
          bgScaleClassName="scale-100"
          pictureClassName="w-full h-full"
        />
      </AspectRatioBox>
    </div>
  );
}

const BG_ASPECT_RATIO_MAP = {
  lg: 420 / 608,
  md: 340 / 468,
  sm: 340 / 353,
};
